"use strict";

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var custom_progress_spinner_module_scss_1 = __importDefault(require("./custom-progress-spinner.module.scss"));

var clsx_1 = __importDefault(require("clsx"));

var styles_1 = require("@material-ui/core/styles");

var colors_1 = require("@material-ui/core/colors");

var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));

var Fab_1 = __importDefault(require("@material-ui/core/Fab"));

var Check_1 = __importDefault(require("@material-ui/icons/Check"));

var useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative'
    },
    buttonSuccess: {
      pointerEvents: 'none',
      backgroundColor: colors_1.green[500],
      '&:hover': {
        backgroundColor: colors_1.green[700]
      }
    },
    fabProgress: {
      color: colors_1.green[500],
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1
    }
  });
});

var CustomProgressSpinner = function CustomProgressSpinner(_ref) {
  var _clsx_1$default;

  var isPending = _ref.isPending,
      isDone = _ref.isDone,
      ProgressIcon = _ref.ProgressIcon;
  var classes = useStyles();
  var buttonClassname = clsx_1.default((_clsx_1$default = {}, _defineProperty(_clsx_1$default, classes.buttonSuccess, isDone), _defineProperty(_clsx_1$default, custom_progress_spinner_module_scss_1.default.animate, isDone), _clsx_1$default));
  return react_1.default.createElement("div", {
    className: classes.wrapper
  }, react_1.default.createElement(Fab_1.default, {
    "aria-label": "save",
    color: "primary",
    className: buttonClassname
  }, isDone ? react_1.default.createElement(Check_1.default, null) : react_1.default.createElement(ProgressIcon, null)), isPending && react_1.default.createElement(CircularProgress_1.default, {
    size: 68,
    className: classes.fabProgress
  }));
};

exports.default = CustomProgressSpinner;